var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"retention-analysis-table-cont"},[_c('t-enhanced-table',{ref:"table",attrs:{"row-key":"id","columns":_vm.columns,"data":_vm.data,"pagination":_vm.pagination}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }